
export const getConstrainedAmount = (amount, product) => {
    const min = Math.round(product.baseValue * 100) / 100;
    const max = Math.round(product.maxValue * 100) / 100;
    const parsedAmount = Math.round(amount * 100) / 100;
    if (parsedAmount < min) return min;
    if (parsedAmount > max) return max;
    return parsedAmount;
};

export const getDefaultDenomination = (defaultDenom, product) => {
    const min = Math.round(product.baseValue * 100) / 100;
    const max = Math.round(product.maxValue * 100) / 100;
    if (min === max || max < defaultDenom) return max;
    if (min >= defaultDenom) return min;
    return defaultDenom;
};
